import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import styles from "./accordion.module.css";
import AccordionItem from "./item.component";
var Accordion = function(param) {
    var items = param.items, title = param.title, buttonId = param.buttonId, sectionId = param.sectionId, onItemToggle = param.onItemToggle, _theme = param.theme, theme = _theme === void 0 ? "standard" : _theme;
    var ref = useState(), currentFocusAccordion = ref[0], setCurrentFocusAccordion = ref[1];
    var itemsEls = useRef([]);
    var totalItems = items.length;
    useEffect(function() {
        itemsEls.current = Array.from({
            length: items.length
        });
    }, [
        items
    ]);
    useEffect(function() {
        if (!currentFocusAccordion) return;
        if (itemsEls.current[currentFocusAccordion]) {
            itemsEls.current[currentFocusAccordion].focus();
        }
    }, [
        currentFocusAccordion,
        itemsEls
    ]);
    return /*#__PURE__*/ _jsx("section", {
        className: classnames(styles.accordion),
        "aria-label": "".concat(title, " - ").concat(totalItems, " items"),
        children: items.map(function(item, index) {
            var id = index + 1;
            var keyName = "accordion-".concat(id);
            var getRef = function(el) {
                return itemsEls.current[id] = el;
            };
            return /*#__PURE__*/ _jsx(AccordionItem, {
                title: item.title,
                id: id,
                onToggleExpanded: function(isOpen) {
                    return onItemToggle && onItemToggle(index, isOpen);
                },
                setCurrentFocusAccordion: setCurrentFocusAccordion,
                totalItems: totalItems,
                ref: getRef,
                buttonId: buttonId,
                sectionId: sectionId,
                iconType: item.iconType,
                iconGradient: item.iconGradient,
                theme: theme,
                children: item.children
            }, keyName);
        })
    });
};
export default Accordion;
